import React, { useState, useEffect, useRef } from 'react';
import './YearCalendar.css';
import { useDispatch } from "react-redux";
import {
SetSelectedYear
} from "../redux/counterSlice";

const YearCalendar = ({ startYear, endYear, value, onChange, compareYear = false }) => {
  const dispatch = useDispatch();
  const years = [];
  for (let i = startYear; i <= endYear; i++) years.push(i);

  const today = new Date();
  const currentYear = today.getFullYear();
  const yearsPerPage = 9;
  const numPages = Math.ceil(years.length / yearsPerPage);
  const currentYearPage = Math.floor((currentYear - startYear) / yearsPerPage);

  const initialPage =
    value !== undefined && value !== null
      ? Math.max(Math.floor((value - startYear) / yearsPerPage), 0)
      : 0;

  const [currentPage, setCurrentPage] = useState(initialPage);
  const [selectedYear, setSelectedYear] = useState(
    value !== undefined && value !== null ? value : compareYear ? null : currentYear
  );
  const [showCalendar, setShowCalendar] = useState(false);

  const calendarRef = useRef();
  const currentPageYears = years.slice(
    currentPage * yearsPerPage,
    (currentPage + 1) * yearsPerPage
  );

  const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 0));
  const handleNextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, numPages - 1));

  const handleToggleCalendar = () => {
    if (!showCalendar) {
      const pageForSelectedYear = selectedYear
        ? Math.floor((selectedYear - startYear) / yearsPerPage)
        : currentYearPage;
      setCurrentPage(Math.max(0, Math.min(pageForSelectedYear, numPages - 1)));
    }
    setShowCalendar(!showCalendar);
  };

  const handleYearClick = (year) => {
    setSelectedYear(year);
    setShowCalendar(false);
    if (compareYear && onChange) {
      onChange(year); // lift compare year to parent
      return;
    }
    // Only dispatch Redux for past year calendar
    if (!compareYear) {
      dispatch(SetSelectedYear(new Date(year, 0, 1).getTime()));
    }
  };

  const handleClickOutside = (event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setShowCalendar(false);
    }
  };
  useEffect(() => {
    if(!compareYear)
    {
      const date = new Date(selectedYear, 0, 1, 0, 0, 0, 0);
      dispatch(SetSelectedYear(date.getTime()));
      return () => {
        const date = new Date(currentYear, 0, 1, 0, 0, 0, 0);
        dispatch(SetSelectedYear(date.getTime()));
      };
    }
  }, []);
  useEffect(() => {
    if(!compareYear)
    {
      const date = new Date(selectedYear, 0, 1, 0, 0, 0, 0);
      dispatch(SetSelectedYear(date.getTime()))
    }
  }, [selectedYear]);
  
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={calendarRef} className="yearCalendar">
      <input
        type="text"
        readOnly
        value={selectedYear || ""}
        placeholder="Select year"
        onClick={handleToggleCalendar}
        style={{ cursor: "pointer", width: "311px", height: "30px" }}
      />
      {showCalendar && (
        <div className="custom-calendar-popup">
          <div className="pagination">
            <button onClick={handlePrevPage} disabled={currentPage === 0}>
              &larr;
            </button>
            <button
              onClick={handleNextPage}
              disabled={currentPage === numPages - 1}
            >
              &rarr;
            </button>
          </div>
          <div className="year-calendar">
            {currentPageYears.map((year) => (
              <div
                key={year}
                className={`year-cell ${
                  year === currentYear ? "current-year" : ""
                } ${year === selectedYear ? "selected-year" : ""}`}
                onClick={() => handleYearClick(year)}
              >
                {year}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
export default YearCalendar;